import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { InfoTooltip } from "../info-tooltip";
import type { MetricCardProps } from "./types";
import {
  BADGE_BOX_STYLES, BADGE_ICON_STYLES, BADGE_TEXT_STYLES,
  CARD_COLORS, CARD_CONTAINER_STYLES, FALLBACK,
  SUBTITLE_STYLES, VALUE_STYLES,
} from "./styles";

export const MetricCard: React.FC<MetricCardProps> = ({
  badge, badgeIcon, value, subtitle, tooltip, isLoading = false, isError = false,
}) => {
  const colors = CARD_COLORS[badge.toUpperCase()] ?? FALLBACK;
  return (
    <Box sx={CARD_CONTAINER_STYLES(colors)}>
      <Box sx={BADGE_BOX_STYLES(colors)}>
        <Box sx={BADGE_ICON_STYLES(colors)}>{badgeIcon}</Box>
        <Typography sx={BADGE_TEXT_STYLES(colors)}>{badge}</Typography>
      </Box>
      <Box sx={{ minHeight: 36, display: "flex", alignItems: "center" }}>
        {isLoading ? <CircularProgress size={24} /> : (
          <Typography sx={VALUE_STYLES(colors, isError)}>
            {isError ? "—" : value}
          </Typography>
        )}
      </Box>
      <Typography sx={SUBTITLE_STYLES}>
        {subtitle}
        {tooltip && <InfoTooltip tooltip={tooltip} colors={colors} />}
      </Typography>
    </Box>
  );
};
